import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Button, Drawer, Space, Table } from 'antd';
import { DownloadOutlined } from "@ant-design/icons";
import moment from 'moment';

import Loader from '../../../Home/Loader/Loader';
import { viewProductionHistory } from '../../../redux/actions/API/production';
import { isValidJSON } from '../../utility/itemsUtility';
import { downloadExcel } from '../../../Utility/downloadExcel';

interface ProductionHistoryProps {
    openHistory: boolean;
    setOpenHistory: Function;
    productionId?: string;
    historyData: any;
    viewHistoryLoading: boolean;
    viewProductionHistory: Function;
    navigationId: string;
    isBulkProduction?: boolean;
    bulkProductionId?: string;
}

const ProductionHistory: React.FC<ProductionHistoryProps> = ({
    setOpenHistory,
    openHistory,
    productionId,
    historyData,
    viewHistoryLoading,
    viewProductionHistory,
    isBulkProduction = false,
    bulkProductionId,
    navigationId
}) => {

    useEffect(() => {
        if (openHistory) {
            if(isBulkProduction) {
                viewProductionHistory({ isBulkProduction, bulkProductionId });
            }else{
            viewProductionHistory({ productionId });
            }
        }
    }, [openHistory]);

    const columns: any = [
        {
            title: isBulkProduction ? "Bulk Production Id" : "Production Id",
            dataIndex: "productionId",
            key: "productionId",
            render: (text: string) => {
                return navigationId
            }
        },
        {
            title: "Action Date/Time",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text: string) => {
                return moment(new Date(text)).format('DD:MM:YYYY, HH:mm')
            }
        },
        {
            title: "Action Type",
            dataIndex: "actionType",
            key: "actionType",
        },
        {
            title: "Summary",
            dataIndex: "summary",
            key: "summary",
            render: (text: string) => {
                return isValidJSON(text);
            }
        },
    ];

    return (
        <>
            <Loader loading={viewHistoryLoading} />
            <Drawer
                title={'Add Production'}
                width={1000}
                onClose={() => {
                    setOpenHistory(false);
                }}
                open={openHistory}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
                extra={
                    <Space>
                        <Button
                            onClick={() => {
                                const data = historyData?.map((history: any) => ({
                                    "ProductionId": navigationId,
                                    "Action Date/Time": moment(history?.createdAt).format('DD:MM:YYYY, HH:mm'),
                                    "Action Type": history?.actionType || '',
                                    "Summary": isValidJSON(history?.summary) || ''
                                }));

                                downloadExcel(data, 'Production History');
                            }}
                        >
                            <DownloadOutlined /> Download
                        </Button>

                    </Space>
                }
            >
                <Table
                    columns={columns}
                    dataSource={Array.isArray(historyData) ? historyData : []}
                    scroll={{ x: "100%", y: 'calc(100vh - 220px)' }}
                    pagination={false}
                />
            </Drawer>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    historyData: state.api.viewProductionHistory.data,
    viewHistoryLoading: state.api.viewProductionHistory.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
    viewProductionHistory: (payload: any) => dispatch(viewProductionHistory(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductionHistory);
